"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*@ngInject*/
exports.default = ['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('profile', {
            url: '/profile',
            template: require('../views/profile-basic.html'),
            controller: 'ProfileBasicController',
            controllerAs: 'profileBasic'
        })
            .state('profile-address', {
            url: '/profile/address',
            template: require('../views/profile-address.html'),
            controller: 'ProfileAddressController',
            controllerAs: 'profileAddress'
        })
            .state('profile-access', {
            url: '/profile/access',
            template: require('../views/profile-access.html'),
            controller: 'ProfileAccessController',
            controllerAs: 'profileAccess',
            resolve: {
                user: ['api', function (api) {
                        return api.get('/profile')
                            .then(function (item) {
                            return item;
                        }, function (err) {
                            console.log(err);
                        });
                    }]
            }
        });
    }];



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/profile/config/routes.js
// module id = 440
// module chunks = 0